import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertModule } from 'ngx-bootstrap/alert';
import { InicioComponent } from './page/inicio/inicio.component';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { SortableModule } from 'ngx-bootstrap/sortable';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrMaskerModule } from 'br-mask';

import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';

import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { ApiService } from './service/api.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { EntrarComponent } from './page/entrar/entrar.component';
import { TemosUsoComponent } from './page/temos-uso/temos-uso.component';
import { PoliticaprivacidadeComponent } from './page/politicaprivacidade/politicaprivacidade.component';
import { EmpresascertificadasComponent } from './page/empresascertificadas/empresascertificadas.component';
import { AvaliacaoComponent } from './page/avaliacao/avaliacao.component';
import { ComofuncionaComponent } from './page/comofunciona/comofunciona.component';
import { ClassificacaoComponent } from './page/classificacao/classificacao.component';
import { EmpresasComponent } from './page/empresas/empresas.component';
import { RecuperarsenhaComponent } from './page/recuperarsenha/recuperarsenha.component';
import { AutenticarComponent } from './page/autenticar/autenticar.component';
import { EmpresasAuditarComponent } from './page/empresas-auditar/empresas-auditar.component';
import { AvaliacaoAuditorComponent } from './page/avaliacao-auditor/avaliacao-auditor.component';
import { EmpresasSegurasComponent } from './page/empresas-seguras/empresas-seguras.component';
import { CadastroComponent } from './page/cadastro/cadastro.component';
import { MapsComponent } from './page/maps/maps.component';
import { AgmCoreModule } from '@agm/core';
import { CertificadoComponent } from './page/certificado/certificado.component';
import { MateriaisComponent } from './page/materiais/materiais.component';
import { ResultadoautoavaliacaoComponent } from './page/resultadoautoavaliacao/resultadoautoavaliacao.component';
import { AdesaoComponent } from './page/adesao/adesao.component';

@NgModule({
  declarations: [
    AppComponent,
    InicioComponent,
    EntrarComponent,
    TemosUsoComponent,
    PoliticaprivacidadeComponent,
    EmpresascertificadasComponent,
    AvaliacaoComponent,
    ComofuncionaComponent,
    ClassificacaoComponent,
    EmpresasComponent,
    RecuperarsenhaComponent,
    AutenticarComponent,
    EmpresasAuditarComponent,
    AvaliacaoAuditorComponent,
    EmpresasSegurasComponent,
    CadastroComponent,
    MapsComponent,
    CertificadoComponent,
    MateriaisComponent,
    ResultadoautoavaliacaoComponent,
    AdesaoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AccordionModule.forRoot(),
    BrowserAnimationsModule,
    AlertModule.forRoot(),
    ButtonsModule.forRoot(),
    //CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    PopoverModule.forRoot(),
    ProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    SortableModule.forRoot(),
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
    BrMaskerModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    CarouselModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDtm2cRzQx-eUZhNbaKoBQM5MEXooBa3Hw'
    }),
    BackButtonDisableModule.forRoot({
      preserveScrollPosition: true
    })
  ],
  providers: [ApiService, NgxSpinnerService, ToastrService, { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: LOCALE_ID, useValue: 'pt-BR' }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
